import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HomeHeader } from '../components/home-header/home-header';
 import { HomeTopAreas } from '../components/home-top-areas/home-top-areas';
import { HomeWhyStayAt } from '../components/home-why-stay-at/home-why-stay-at';
import { HomeWhoAreYou } from '../components/home-who-are-you/home-who-are-you';
import { HomeHowDoesStayAtWork } from '../components/home-how-does-stay-at-work/home-how-does-stay-at-work';
import { HomeReport } from '../components/home-report/home-report';
import { HomeOurCustomersSay } from "../components/home-our-customers-say/home-our-customers-say";
import { DownloadTheAppNow } from "../components/download-the-app-now/download-the-app-now";
 import { HomeFeaturedUnits } from '../components/home-featured-units/home-featured-units';
import { HomeProjects } from '../components/home-projects/home-projects';

@Component({
  selector: 'app-home-page',
  imports: [
    HomeHeader,
    HomeFeaturedUnits,
    HomeProjects,
    HomeTopAreas,
    HomeWhyStayAt,
    HomeWhoAreYou,
    HomeHowDoesStayAtWork,
    HomeReport,
    HomeOurCustomersSay,
    DownloadTheAppNow
],
  templateUrl: './home.page.html',
  styleUrl: './home.page.scss',
})
export class HomePage {
  constructor(private router: Router) {}

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }

  goToRegister() {
    this.router.navigate(['/auth/register']);
  }

  goToSignIn() {
    this.router.navigate(['/auth/sign-in']);
  }

  goToSignUp() {
    this.router.navigate(['/auth/sign-up']);
  }

  goToRegisterPop() {
    this.router.navigate(['/auth/register-pop']);
  }
}
